import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { InsurerLogoComponent } from '@sc/ui-components';

@Component({
  selector: 'sc-home-customer',
  styleUrls: ['./home.container.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InsurerLogoComponent],
  template: `
    <div class="container">
      <sc-insurer-logo></sc-insurer-logo>
    </div>
  `,
})
export class HomeContainer {}
